var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStopCall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_774_27017",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 17,
  height: 16
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 0.439941H0.770508V15.5599H17V0.439941Z",
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_774_27017)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6224 15.0166C14.0462 15.0166 12.4891 14.6964 10.9508 14.0563C9.41254 13.416 8.01293 12.5086 6.75208 11.3339C5.49123 10.1593 4.51718 8.85533 3.82995 7.4222C3.14281 5.9891 2.7992 4.53837 2.7992 3.07C2.7992 2.85857 2.87485 2.68236 3.02614 2.5414C3.17744 2.40044 3.3666 2.32996 3.59354 2.32996H6.6575C6.83404 2.32996 6.99164 2.38576 7.13031 2.49735C7.26899 2.60895 7.35095 2.74109 7.37619 2.89381L7.86795 5.36064C7.89319 5.54859 7.88688 5.70718 7.84901 5.83639C7.81123 5.9656 7.74189 6.0772 7.641 6.17118L5.80644 7.89798C6.05863 8.3326 6.35806 8.75251 6.70474 9.15781C7.05151 9.56311 7.4329 9.95363 7.84901 10.3295C8.23987 10.6938 8.64967 11.0314 9.07839 11.3427C9.50712 11.654 9.96101 11.9389 10.4401 12.1973L12.218 10.541C12.3315 10.4353 12.4797 10.356 12.6625 10.3032C12.8453 10.2502 13.025 10.2356 13.2015 10.2591L15.8115 10.7525C15.988 10.7994 16.133 10.8846 16.2465 11.0079C16.36 11.1313 16.4167 11.2693 16.4167 11.422V14.2765C16.4167 14.4879 16.3411 14.6642 16.1898 14.8051C16.0385 14.9461 15.8493 15.0166 15.6224 15.0166Z",
  fill: "#F78222"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.05811 14.516L14.7125 2.86163",
  stroke: "#F78222",
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStopCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/stopCall.711d40148d7dc9cc79cc5fe3a15b4b12.svg";